export function updateToggle(button, options) {
    button.setAttribute('aria-checked', String(options.checked));
    button.disabled = !!options.disabled;
}
export function createToggle(doc, options) {
    const button = doc.createElement('button');
    button.type = 'button';
    button.className = 'oq-toggle';
    button.setAttribute('role', 'switch');
    button.setAttribute('aria-label', options.label);
    const thumb = doc.createElement('span');
    thumb.className = 'oq-toggle__thumb';
    thumb.setAttribute('aria-hidden', 'true');
    button.append(thumb);
    updateToggle(button, options);
    button.addEventListener('click', () => options.onChange?.(button.getAttribute('aria-checked') !== 'true'));
    return button;
}
//# sourceMappingURL=toggleDom.js.map